import BuyReports from "../components/report-buy-logs";

const BuyRegistersReportPage = () => {
  return <BuyReports />;
};

export default BuyRegistersReportPage;
